import { useState } from 'react';

import { SORT_DIRECTION } from '../../../constants/sort';

const useSliceFilterOpts = ({ initialFilter = {} } = {}) => {
  const [filter, setFilter] = useState({
    offset: 0,
    limit: 25,
    page: 0,
    // As per the platform, expects { field, direction }
    sortBy: [],
    ...initialFilter,
  });

  const onFilterUpdate = updatedFilter => {
    setFilter({
      ...filter,
      ...updatedFilter,
    });
  };

  const toggleSortOption = sortOption => {
    const isSortedByOption = filter.sortBy.find(
      option => option.field === sortOption.field,
    );

    if (isSortedByOption) {
      setFilter(({ sortBy, ...currentFilter }) => ({
        ...currentFilter,
        sortBy: sortBy.filter(option => option.field !== sortOption.field),
      }));
    } else {
      setFilter(({ sortBy, ...currentFilter }) => ({
        ...currentFilter,
        sortBy: [
          ...sortBy,
          // Default to DESC
          { direction: SORT_DIRECTION.DESC, ...sortOption },
        ],
      }));
    }
  };

  const toggleSortOptionDirection = sortOption => {
    setFilter(({ sortBy, ...currentFilter }) => ({
      ...currentFilter,
      sortBy: sortBy.map(option => {
        if (option.field !== sortOption.field) {
          return option;
        }

        return {
          ...option,
          direction:
            option.direction === SORT_DIRECTION.DESC
              ? SORT_DIRECTION.ASC
              : SORT_DIRECTION.DESC,
        };
      }),
    }));
  };

  const onPageChange = page => {
    onFilterUpdate({
      page,
      offset: page * filter.limit,
    });
  };

  return {
    filter,
    toggleSortOption,
    toggleSortOptionDirection,
    onFilterUpdate,
    onPageChange,
  };
};

export default useSliceFilterOpts;
